export const environment = {
    production: false,
    statsUrl: 'http://guide.dev.iam.aha.org/stats/',
    guideUrl: 'http://guide.dev.iam.aha.org/guide/',
    dataQueryUrl : 'http://guide.dev.iam.aha.org/dataquery/',
    dataQueryUrlSideNav : 'https://guide.dev.iam.aha.org/dataquery',
  };



// WEBPACK FOOTER //
// ./src/environments/environment.ts